import {
  ADD_SUPPORT_TASK_SUCCESS,
  ADD_TASK_SUCCESS,
  GET_ALL_BOARD_SUCCESS,
  GET_COMPANY_INFO,
  GET_COMPANY_INFO_SUCCESS,
  GET_SELECTED_BOARD_SUCCESS,
  GET_SELECTED_TASK_FAILED,
  GET_SELECTED_TASK_SUCCESS,
  GetAllBoardsSuccessAction,
  GetCompanyInfoSuccessAction,
  GetSelectedBoardSuccessAction,
  GetSelectedTaskFailedAction,
  GetSelectedTaskSuccessAction,
  RESET_SELECTED_TASK,
  SET_DIALOG_ATTACHMENT, SET_TASK_VIEW_UPDATE_INFO,
  SetDialogAttachmentAction, SetTaskViewUpdateInfoAction,
  TaskManagerActions
} from './task-manager.action';

export interface TaskManagerState {
  selectedBoard: any;
  selectedTaskById: any;
  createdSupportTask: any;
  boardForSelectedTaskById: any;
  companyBoards: any[];
  supportBoards: any[];
  statusList: any[];
  dueStateList: any[];
  taskManagementMenuList: any[];
  taskCreationMenuList: any[];
  unsavedTask: any;
  attachmentInfo: any;
  companyInfo: any;
  getFailedTaskId: any;
  taskViewUpdatedInfo: any;
}

export const initialState = <TaskManagerState>{
  selectedBoard: null,
  selectedTaskById: null,
  createdSupportTask: null,
  boardForSelectedTaskById: null,
  companyBoards: [],
  supportBoards: [],
  statusList: [],
  dueStateList: [],
  taskManagementMenuList: [],
  taskCreationMenuList: [{
    id: 'TaskDetail',
    name: 'Detail',
    title: 'Detail',
    order: 1,
    isSelected: true,
    editor: 'TaskDetailComponent',
    type: 'TaskDialogMenu'
  }],
  unsavedTask: null,
  attachmentInfo: null,
  companyInfo: null,
  taskViewUpdatedInfo: null
};

export function taskManagerReducer(state: TaskManagerState = initialState, action: TaskManagerActions) {
  switch (action.type) {

    case GET_ALL_BOARD_SUCCESS: {
      const boardsObj = (action as GetAllBoardsSuccessAction).data;

      return {
        ...state,
        companyBoards: boardsObj.companyBoards,
        supportBoards: boardsObj.supportBoards,
        selectedBoard: null,
        statusList: []
      };
    }
    case GET_SELECTED_BOARD_SUCCESS: {
      const boardObj = (action as GetSelectedBoardSuccessAction).data.board;
      if (!boardObj) {
        return {
          ...state
        };
      }
      return {
        ...state,
        selectedBoard: boardObj,
        statusList: boardObj.lists.map(l => {
          return {
            status: l.status,
            name: l.name
          };
        }),
        dueStateList: boardObj.dueStateList
      };
    }
    case ADD_TASK_SUCCESS: {
      return {
        ...state,
        selectedTaskById: null,
        boardForSelectedTaskById: null
      };
    }
    case GET_SELECTED_TASK_SUCCESS: {
      const taskObj = (action as GetSelectedTaskSuccessAction).data.ticketWithBoard;
      if (!taskObj) {
        return state;
      }
      const boardObj = (action as GetSelectedTaskSuccessAction).data.ticketWithBoard.board;
      return {
        ...state,
        selectedTaskById: taskObj,
        boardForSelectedTaskById: boardObj,
        statusList: boardObj.lists.map(l => {
          return {
            status: l.status,
            name: l.name
          };
        }),
        dueStateList: boardObj.dueStateList
      };
    }
    case RESET_SELECTED_TASK: {
      return {
        ...state,
        selectedTaskById: null,
        boardForSelectedTaskById: null
      };
    }
    case ADD_SUPPORT_TASK_SUCCESS: {
      return {
        ...state,
        createdSupportTask: action.payload
      };
    }
    case SET_DIALOG_ATTACHMENT: {
      const attachmentInfo = (action as SetDialogAttachmentAction).attachmentInfo;
      return {
        ...state,
        attachmentInfo: attachmentInfo,
      };
    }
      case SET_TASK_VIEW_UPDATE_INFO: {
      const  updatedTaskViewInfo = (action as SetTaskViewUpdateInfoAction).updatedTaskViewInfo;
      return {
        ...state,
        taskViewUpdatedInfo: updatedTaskViewInfo
      };
    }
    case GET_COMPANY_INFO: {
      return {
        ...state,
        companyInfo: null
      };
    }
    case GET_COMPANY_INFO_SUCCESS: {
      return {
        ...state,
        companyInfo: (action as GetCompanyInfoSuccessAction).companyInfo
      };
    }
    case GET_SELECTED_TASK_FAILED: {
      return {
        ...state,
        payload: (action as GetSelectedTaskFailedAction).payload,
        getFailedTaskId: (action as GetSelectedTaskFailedAction).taskId
      };

    }
    default:
      return state;
  }
}

